import { motion } from "framer-motion";
import { Reveal, SectionLabel } from "./Reveal";

export const Roster = ({ fighters = [], loading, section }) => {
  if (!section) return null;

  const maxItems = Number(section.metadata?.max_items || 2);

  return (
    <section id="roster" data-testid="roster-section" className="relative py-24 md:py-32 bg-[#0a0a0a]">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-16">
          <div>
            <Reveal>
              <SectionLabel index={section.metadata?.section_index || "02"}>{section.eyebrow}</SectionLabel>
            </Reveal>
            <Reveal delay={0.1}>
              <h2 className="font-anton uppercase text-[#FAFAFA] text-5xl md:text-7xl lg:text-8xl leading-[0.9]">
                {section.title} <span className="text-[#E85A24]">{section.title_accent}</span>
              </h2>
            </Reveal>
          </div>
          {section.body && (
            <Reveal delay={0.2}>
              <p className="font-dm text-[#A3A3A3] max-w-sm">{section.body}</p>
            </Reveal>
          )}
        </div>

        {loading && (
          <p data-testid="roster-loading" className="font-oswald uppercase tracking-widest text-[#A3A3A3]">
            {section.metadata?.loading_text || "Loading fighters…"}
          </p>
        )}

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-px bg-white/10 border border-white/10 max-w-3xl mx-auto">
          {fighters.slice(0, maxItems).map((fighter, index) => (
            <Reveal key={fighter.id} delay={index * 0.08}>
              <motion.article
                data-testid={`fighter-card-${fighter.id}`}
                className="group relative bg-[#050505] overflow-hidden h-full"
              >
                <div className="relative aspect-[4/5] overflow-hidden">
                  <img
                    src={fighter.image}
                    alt={fighter.name}
                    className="w-full h-full object-cover object-top grayscale group-hover:grayscale-0 scale-100 group-hover:scale-105 transition-[transform,filter] duration-700 ease-out"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black via-black/30 to-transparent" />
                  <span className="absolute top-4 right-4 font-oswald text-xs tracking-widest uppercase text-[#E85A24] border border-[#E85A24]/40 px-3 py-1 bg-black/40">
                    {fighter.record}
                  </span>
                </div>

                <div className="p-6">
                  <p className="font-oswald uppercase tracking-[0.25em] text-[11px] text-[#E85A24] mb-1">
                    &ldquo;{fighter.nickname}&rdquo;
                  </p>
                  <h3 className="font-anton uppercase text-2xl text-[#FAFAFA] leading-none group-hover:text-[#E85A24] transition-colors duration-300">
                    {fighter.name}
                  </h3>
                  <div className="mt-4 pt-4 border-t border-white/10 flex justify-between font-dm text-sm text-[#A3A3A3]">
                    <span>{fighter.weight_class}</span>
                    <span>{fighter.knockouts} KO</span>
                  </div>
                  <p className="font-dm text-xs text-[#A3A3A3]/70 mt-2">
                    {fighter.nationality} · {fighter.stance}
                  </p>
                </div>
              </motion.article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
